import React from "react";
import { Form, Input, Row, Col, Divider } from "antd";

const Notifications: React.FC = () => {
  return (
    <div style={{ padding: "20px" }}>
      
      <div className="profile-headers">Notifications</div>

      <div>
      <div
      style={{
        display: "flex",
        alignItems: "center",
        padding: "16px",
        background: "#fff",
        width: "100%",
      }}
    >
      {/* Left Image */}
      <img
        src='/Home/fastestBg.svg'
        alt="Food"
        style={{
          width: "90px",
          height: "90px",
          borderRadius: "50%",
          objectFit: "cover",
          marginRight: "25px",
        }}
      />

      {/* Name + Description */}
      <div style={{ flex: 1 }}>
        <div
          style={{
            fontWeight: 600,
            fontSize: "18px",
            opacity: 0.7,
            marginBottom: "15px",
          }}
        >
          Food Item Name
        </div>
        <div
          style={{
            fontWeight: 500,
            fontSize: "16px",
            opacity: 0.4,
          }}
        >
          Delicious spicy burrito with extra cheese
        </div>
      </div>

      {/* Right End - Track Now */}
      <div
        style={{
          fontWeight: 600,
          fontSize: "16px",
          color: "#C32340",
          cursor: "pointer",
        }}
      >
        Track Now
      </div>
    </div>
    <Divider/>
      </div>
      
    </div>
  );
};

export default Notifications;
